<template>
  <div class="leave-msg">
    <div class="leave-msg__leave-header">
      <div class="leave-msg__leave-title">留言信息</div>
      <div class="leave-msg__header-btn" v-if="[3, 4].includes(page.chatMsgForm.msgStatus)" @click="commentOpen">
        评价
      </div>
    </div>
    <custom-assembly
      v-if="Object.keys(page.chatMsgForm.extendedFields).length > 0"
      ref="dataFormRef"
      v-model="page.chatMsgForm.extendedFields"
      v-bind="page.formProps"
    />
    <div class="leave-msg__leave-text">状态：{{ statusObj[page.chatMsgForm.msgStatus || 0] }}</div>
    <div class="leave-msg__leave-text" v-if="![0, 1].includes(page.chatMsgForm.msgStatus)">
      处理时间：{{ dateTimeFormat(page.chatMsgForm.dealTime) }}
    </div>
    <!--留言回复列表-->
    <div class="replay-list" v-if="page.visibleDealMsgList.length > 0">
      <div class="replay-list__line"></div>
      <div v-for="o in page.visibleDealMsgList" :key="o.index" class="replay-list__item flex">
        <img src="@/assets/images/head.png" class="replay-list__item-avatar" />
        <div class="flex flex-column flex-1">
          <div class="replay-list__item-name flex flex-between">
            <div>平台</div>
            <div>{{ dateTimeFormat(o.dealTime) }}</div>
          </div>
          <div class="replay-list__item-content">{{ o.dealContent }}</div>
        </div>
      </div>
      <div class="replay-list__load-more" v-if="page.dealMsgList.length >= 2">
        <button v-if="page.hasMoreItems" @click="toggleMoreItems(1)">查看更多回复 ></button>
        <button v-else @click="toggleMoreItems(0)">收起</button>
      </div>
    </div>
  </div>
  <chat-evaluate ref="chatcommentRef" @change="evalChange" />
</template>

<script setup>
import CustomAssembly from '@/components/custom/custom-assembly.vue'
import { dateTimeFormat, isJSON } from '@/utils'
import { ElMessage } from 'element-plus'
import { defineProps, getCurrentInstance, nextTick, reactive, ref, watch } from 'vue'
import ChatEvaluate from '@/view/common/ChatEvaluate.vue'

const props = defineProps({
  message: { type: Object },
  orgId: { type: String }
})
const statusObj = {
  0: '未处理',
  1: '未处理',
  2: '处理中',
  3: '已处理',
  4: '已处理'
}
const page = reactive({
  dealMsgList: [],
  chatMsgForm: { msgStatus: 0 },
  hasMoreItems: false,
  visibleDealMsgList: [],
  formProps: {
    isEditor: false,
    labelWidth: 'auto',
    meta: { formList: [], groupList: [] }
  }
})
const { proxy } = getCurrentInstance()
const getDealMsgList = async () => {
  if (props.message && props.message.msgId) {
    let res = await proxy.$http.post('/app/custClient/getDealLeaveMsg', { msgId: props.message.msgId })
    if (res.code === 0) {
      let { list, csLeaveMsgEntity } = res.data
      page.dealMsgList = list || []
      page.chatMsgForm = csLeaveMsgEntity || {}
      if (page.chatMsgForm.extendedFields) {
        page.chatMsgForm.extendedFields = isJSON(page.chatMsgForm?.extendedFields)
          ? handleDataJson(JSON.parse(page.chatMsgForm.extendedFields))
          : {}
        if (Object.keys(page.chatMsgForm.extendedFields).length > 0) {
          init()
        }
      }
      if (list.length > 0 && page.visibleDealMsgList.length === 0) {
        page.visibleDealMsgList.push(list[0])
      }
      page.hasMoreItems = list.length >= 2 ? true : false
    } else {
      ElMessage.error(res.msg)
    }
  }
}
watch(
  () => props.message,
  () => {
    if (props.message) {
      page.chatMsgForm = props.message
      page.chatMsgForm.msgStatus = 0
      //获取处理留言列表
      getDealMsgList()
    }
  },
  { immediate: true}
)
const toggleMoreItems = (type) => {
  if (type === 1 && page.visibleDealMsgList.length < page.dealMsgList.length) {
    page.visibleDealMsgList = page.dealMsgList
    page.hasMoreItems = false
  } else if (type === 0) {
    page.visibleDealMsgList = [page.dealMsgList[0]]
    page.hasMoreItems = true
  }
}
// 留言评价
const chatcommentRef = ref(null)
const commentOpen = () => {
  nextTick(() => {
    chatcommentRef.value.init(page.chatMsgForm)
  })
}
const evalChange = (data) => {
  page.chatMsgForm.evaluateScore = data.evaluateScore
  page.chatMsgForm.evaluateContent = data.evaluateContent
}
const dataFormRef = ref(null)
const init = () => {
  Promise.allSettled([getCustomField(), getFieldGroup()]).then((res) => {
    if (res[0].value && res[0].value.length > 0) {
      page.formProps.meta.formList = res[0].value
    }
    if (res[1].value) {
      let json = JSON.parse(res[1].value)
      page.formProps.meta.groupList = json?.msgField || {}
    }
    if (page.formProps.meta.formList.length > 0 && page.formProps.meta.groupList.length > 0) {
      nextTick(() => {
        dataFormRef.value?.init()
      })
    }
  })
}
// 获取留言自定义字段
const getCustomField = () => {
  return new Promise((resolve) => {
    let params = { orgId: props.orgId || 10, type: 5 }
    proxy.$http.post('/app/custClient/getshowlist', params).then((res) => {
      resolve(res.data)
    })
  })
}

// 获取留言配置字段组
const getFieldGroup = async () => {
  return new Promise((resolve) => {
    proxy.$http.post(`/app/custClient/config`, {
      key: 'leave.word',
      orgId: props.orgId
    }).then((res) => {
      resolve(res.data)
    })
  })
}

// 处理客户信息JSON数据
const handleDataJson = (obj) => {
  if (obj?.extendedFields) {
    let customFields = JSON.parse(obj.extendedFields)
    for (let key in customFields) {
      obj[key] = customFields[key]
    }
  }
  return obj
}
</script>
<style lang="less" scoped>
.leave-msg {
  :deep(.el-form-item) {
    margin-bottom: 0;
  }
  :deep(.el-form-item__content) {
    font-size: 12px;
  }
  :deep(.el-form-item__label) {
    font-size: 12px;
    color: #333333;
  }
  :deep(.el-checkbox__label) {
    font-size: 12px;
  }
  &__leave-title {
    font-size: 12px;
    font-weight: bold;
  }

  &__leave-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px; /* 调整标题与内容之间的间距 */
  }

  &__header-btn {
    font-size: 12px;
    color: #007bff; /* 蓝色字体 */
  }

  &__leave-text {
    font-size: 12px;
    margin-top: 5px;
  }
}

.replay-list {
  font-size: 12px;

  &__line {
    margin-top: 8px;
    width: 100%;
    border-bottom: 1px solid silver;
  }

  &__status {
    margin-top: 5px;
  }

  &__item {
    margin-top: 8px;
  }

  &__item-avatar {
    margin-right: 12px;
    width: 30px;
    height: 30px;
    position: relative;
  }

  &__item-name {
    width: 100%;
    font-size: 12px;
    color: #888888;
    line-height: 28px;
  }

  &__item-content {
    font-size: 12px;
    color: #333333;
    line-height: 1.5;
    width: 198px;
    overflow: hidden;
    white-space: pre-wrap;
  }

  &__load-more {
    margin-top: 10px;
    text-align: left;

    button {
      padding: 0; /* 去除内边距 */
      background-color: transparent; /* 透明背景 */
      color: #007bff; /* 蓝色字体 */
      border: none; /* 无边框 */
      font-size: 12px; /* 字体大小 */
      cursor: pointer; /* 鼠标样式 */
    }
  }
}
</style>
